import Button from '@sats-group/ui-lib/react/button';
import Modal from '@sats-group/ui-lib/react/modal';
import React from 'react';
import MembershipCard from '~/client/components/membership-card/membership-card';
import type { ProductOptionList as Props } from './product-option-list.types';

const ProductOptionList: React.FunctionComponent<Props> = ({
  modal,
  moreOptionsLabel,
  onClick,
  optionKey,
  options,
  selected,
}) => {
  if (!options || !options.length) {
    return null;
  }

  return (
    <div className="personal-trainer-select-session-page__section-actions">
      <Button
        text={moreOptionsLabel}
        size={Button.sizes.small}
        variant={Button.variants.secondary}
        popoverTarget={modal.id}
        data-test-product-options
      />
      <Modal {...modal}>
        {onClick
          ? options.map(option => (
              <button
                className="personal-trainer-select-session-page__option"
                key={option.id}
                onClick={() => {
                  onClick(optionKey, option.id);
                }}
                popoverTarget={modal.id}
                popoverTargetAction="hide"
                data-test-product-option
              >
                <MembershipCard
                  {...option}
                  isSelected={option.id === selected}
                />
              </button>
            ))
          : undefined}
      </Modal>
    </div>
  );
};

export default ProductOptionList;
